var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmployeeContributionHistorySummary',{attrs:{"employeeId":_vm.employeeId}}),_c('EmployeeContributionHistory',{attrs:{"employeeId":_vm.employeeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }